import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon } from 'lucide-react';
import { DemoBadge } from './DemoBadge';
import { PosterFallback } from './PosterFallback';
import { formatShortDate, getMetaParts, isUpcoming } from '../utils/production';
import type { Production } from '../types/production';
interface ProductionCardProps {
  production: Production;
}
export function ProductionCard({
  production
}: ProductionCardProps) {
  const upcoming = isUpcoming(production);
  const meta = getMetaParts(production);
  const release = formatShortDate(production.releaseDate);
  return <Link to={`/titulo/${production.slug}`} className="group block rounded-md focus-visible:outline-none" data-id="element-222" data-mp="2r045zewtn7zv">
      <div className="relative aspect-video overflow-hidden rounded-md bg-coal ring-1 ring-white/5 transition-[transform,box-shadow] duration-200 ease-cine group-hover:scale-[1.05] group-hover:shadow-2xl group-hover:shadow-black/70 group-focus-visible:scale-[1.05] group-focus-visible:ring-2 group-focus-visible:ring-white motion-reduce:transform-none" data-id="element-223" data-mp="2vy5lxqyyar74">
        {production.posterUrl ? <img src={production.posterUrl} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-224" data-mp="3fbt0o6gzt85v" /> : <PosterFallback data-id="element-225" data-mp="35fpxcxaen3hc" />}

        <div className="absolute inset-x-0 bottom-0 h-3/4 bg-gradient-to-t from-black/95 via-black/50 to-transparent" data-id="element-226" data-mp="35ckazpt5ufpb" />

        <div className="absolute left-2.5 top-2.5 flex items-center gap-1.5" data-id="element-227" data-mp="1xy4lgog2fi3">
          {production.isDemo && <DemoBadge data-id="element-228" data-mp="3t3ga77zy4d6l" />}
          {production.isOriginal && <span className="rounded-sm bg-white px-1.5 py-0.5 font-display text-[10px] font-black uppercase tracking-[0.12em] text-night" data-id="element-229" data-mp="3t62f0zvgcel4">
              Original
            </span>}
        </div>

        <div className="absolute inset-x-0 bottom-0 p-3 md:p-3.5" data-id="element-230" data-mp="2hmhm1ikjlpux">
          <h3 className="line-clamp-1 font-display text-sm font-bold text-white md:text-base" data-id="element-231" data-mp="2dlnxqo36u91i">
            {production.title}
          </h3>
          {upcoming && release ? <p className="mt-1 flex items-center gap-1.5 text-xs font-medium text-white" data-id="element-232" data-mp="2k2fzr48kp066">
              <CalendarIcon className="h-3.5 w-3.5" data-id="element-233" data-mp="25701so4vgk4i" />
              Estreno · {release}
            </p> : meta.length > 0 && <p className="mt-1 line-clamp-1 text-xs text-mist" data-id="element-234" data-mp="2a7e8a1qtrm0f">{meta.join(' · ')}</p>}
        </div>
      </div>
    </Link>;
}